import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Consignments from "./pages/Consignments";
import CrudPage, { SHIPPER_FIELDS, BRANCH_FIELDS, VEHICLE_FIELDS, AGENT_FIELDS } from "./pages/CrudPage";
import Users from "./pages/Users";
import Companies from "./pages/Companies";
import Reports from "./pages/Reports";
import ActivityLogs from "./pages/ActivityLogs";
import PublicTrack from "./pages/PublicTrack";
import PublicHome from "./pages/PublicHome";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="p-10 text-slate-500">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/track" element={<PublicTrack />} />
          <Route path="/track/:lr" element={<PublicTrack />} />

          <Route path="/app" element={<Protected><Dashboard/></Protected>} />
          <Route path="/app/consignments" element={<Protected><Consignments/></Protected>} />
          <Route path="/app/shippers" element={<Protected><CrudPage title="Shippers" subtitle="Senders" table="shippers" fields={SHIPPER_FIELDS} testIdPrefix="shipper"/></Protected>} />
          <Route path="/app/consignees" element={<Protected><CrudPage title="Consignees" subtitle="Receivers" table="consignees" fields={SHIPPER_FIELDS} testIdPrefix="consignee"/></Protected>} />
          <Route path="/app/branches" element={<Protected><CrudPage title="Branches" subtitle="Hubs across the network" table="branches" fields={BRANCH_FIELDS} testIdPrefix="branch"/></Protected>} />
          <Route path="/app/vehicles" element={<Protected><CrudPage title="Vehicles" subtitle="Fleet" table="vehicles" fields={VEHICLE_FIELDS} testIdPrefix="vehicle"/></Protected>} />
          <Route path="/app/agents" element={<Protected><CrudPage title="Agents" subtitle="Partner agents and carriers" table="agents" fields={AGENT_FIELDS} testIdPrefix="agent"/></Protected>} />
          <Route path="/app/users" element={<Protected roles={["super_admin","company_admin"]}><Users/></Protected>} />
          <Route path="/app/companies" element={<Protected roles={["super_admin"]}><Companies/></Protected>} />
          <Route path="/app/reports" element={<Protected roles={["super_admin","company_admin","manager"]}><Reports/></Protected>} />
          <Route path="/app/activity" element={<Protected roles={["super_admin","company_admin"]}><ActivityLogs/></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
